import React from 'react';
import {
    Typography,
    TextField,
    IconButton,
    InputAdornment,
    makeStyles,
    FormControl, Avatar, Button, Tabs, Tab
} from '@material-ui/core';

// import Select from '@material-ui/core';
import './style.css'
import { useStyles } from './styles';
import { BiRadioCircle, BiRadioCircleMarked } from 'react-icons/bi'
import AudioPlayer from 'material-ui-audio-player'
import DepartmentServices from '../../DepartmentServices/DepartmentServices'
import { useSelector } from 'react-redux';
import Backdrop from '../../../../components/Modal/Backdrop';
import Modal from '../../../../components/Modal/Modal'
import Fileupload from './Fileupload';
import RecordAudio from './RecordAudio';
import ProfileServices from '../../../Profile/ProfileServices/ProfileServices'
import microphone from '../../../../assets/images/Microphone.png'
import upload from '../../../../assets/images/Upload.png'
import ReactAudioPlayer from 'react-audio-player';
import { useParams } from 'react-router-dom';

import { createMuiTheme, ThemeProvider } from '@material-ui/core';
import { TabContext, TabPanel } from '@material-ui/lab';
const muiTheme = createMuiTheme({});


const useStyleses = makeStyles(
    (theme: any) => {
        return {
            root: {
                [theme.breakpoints.down('sm')]: {
                    width: '100%'
                },
            },
            loopIcon: {
                color: '#4D72F8',
                '&.selected': {
                    color: '#0921a9'
                },
                '&:hover': {
                    color: '#4D72F8'
                },
                [theme.breakpoints.down('sm')]: {
                    display: 'none'
                }
            },
            playIcon: {
                color: '#4D72F8',
                fontSize: '28px',
                '&:hover': {
                    color: '#4D72F8'
                }
            },
            pauseIcon: {
                color: '#4D72F8',
                '&:hover': {
                    color: '#4D72F8'
                }
            },
            volumeIcon: {
                color: '#4D72F8',
                fontSize: '28px',
                '&:hover': {
                    color: '#4D72F8'
                }
            },
            volumeSlider: {
                color: '#4D72F8'
            },
            progressTime: {
                color: '#6b6b6d'
            },
            mainSlider: {
                color: '#4D72F8',
                '& .MuiSlider-rail': {
                    color: '#4D72F8'
                },
                '& .MuiSlider-track': {
                    color: '#4D72F8'
                },
                '& .MuiSlider-thumb': {
                    color: '#4D72F8'
                }
            }
        }
    });


function OpenHourGreetingsNew(props: any) {
    const classes = useStyles();
    const [srcss, setSrcss] = React.useState<any>('')
    const [filname, setfilname] = React.useState<any>('')
    const [shouldRecord, setShouldRecord] = React.useState(false)
    // const [openModalAdd, setopenModalAdd] = React.useState(true);
    const [value, setValue] = React.useState("2");



    const handlePopupModalAdd = () => {
        setShouldRecord(!shouldRecord)
        // setopenModalAdd(!openModalAdd)
    }

    const handleLoadMetadata = (meta: any) => {
        const { duration } = meta.target;
        const styles = makeStyles({

        })
        // console.log(duration);
    }

    const handleChange = (event: React.ChangeEvent<{}>, newValue: any) => {
        setValue(newValue);
    };

    // const id = useParams()
    // const paramObj: any = id
    // React.useEffect(()=>{
    //     console.log(props.soundFiles)
    //     setfilname(props.soundFiles.fileName)
    //     setSrcss(props.soundFiles.path)
    // }, [])


    return (
        <>
            {
                shouldRecord && (
                    <div>
                        <Backdrop handlePopupModal={handlePopupModalAdd} />
                        <Modal title={`Edit ${props.title}`} handlePopupModal={handlePopupModalAdd} >
                            <div className={classes.editmodal}>
                                <Tabs
                                
                                    value={value}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    className={classes.tabs}
                                    onChange={handleChange}
                                    id="editOpenHourGreetingsTab"

                                >
                                    {/* <Tab
                                        label="Record Audio"
                                        value="1"
                                        className={value === "1" ? classes.tabActive : classes.tab}
                                    /> */}
                                    <Tab
                                        label="Upload Audio"
                                        value="2"
                                        className={value === "2" ? classes.tabActive : classes.tab}
                                    />

                                </Tabs>
                                <TabContext value={value}>
                                    <TabPanel value="1">
                                        {/* <p>record file</p> */}
                                        <RecordAudio depId={props.depId} />
                                    </TabPanel>
                                    <TabPanel value="2">
                                        {/* <p>File Upload</p> */}
                                        <Fileupload
                                            depId={props.depId}
                                            openHours={props.openHours}
                                            data={props.openHoursGrData}
                                        />
                                    </TabPanel>
                                </TabContext>
                            </div>
                        </Modal>
                    </div>
                )
            }
            {/* <div className={classes.greetMainSection}>
            <Typography className={classes.subheading}>{props.title}</Typography>
            <div style={{ display: 'flex', flexDirection: 'column', width: "389px", height: "248px", background: "#F0F3F5", borderRadius: "7px", marginTop: '38px' }}>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', paddingTop: '17px', marginBottom:'15px'}}>
                    <div className='greeting_card'  onClick={handlePopupModalAdd}>
                        <div className='avatar'>
                            <img src={microphone} style={{ width: 21, height: 21 }} />
                        </div>
                        <p className='avatar_title'>Record</p>
                        <p className='avatar_sub_title'>You can record Your Audio</p>
                    </div>
                    <div className='greeting_card'>
                        <div className='avatar'>
                            <img src={upload} style={{ width: 21, height: 21 }} />
                        </div>
                        <p className='avatar_title'>Upload</p>
                        <p className='avatar_sub_title'>You can upload Your Audio</p>
                    </div>
                </div>
                <div className='greeting_bodysection'>

                    <ThemeProvider theme={muiTheme}>
                        <ReactAudioPlayer
                            controls
                            // className={classes.audioPlayer}
                            onLoadedMetadata={handleLoadMetadata}
                            src={srcss}
                            style={{marginLeft:"10px",width: '197px',height: '31px',background:'#E9ECED',border: "1px",borderStyle:"solid" ,borderColor:"#F0F3F5"}}
                        />
                    </ThemeProvider>

                    <Button className={classes.saveBtn}>
                        <Typography className={classes.saveBtnText}>Save</Typography>
                    </Button>
                </div>
            </div>
        </div> */}

            <div className={classes.greetMainSection}>
                <div style={{ textAlign: 'left' }}>
                    <Typography className={classes.heading}>{props.title}</Typography>
                    <Typography className={classes.actionline}>{props.actionline}</Typography>
                </div>
                <div>
                    <div className={classes.audioContainer}>
                        <ThemeProvider theme={muiTheme}>
                            <ReactAudioPlayer
                                controls
                                // className={classes.audioPlayer}
                                onLoadedMetadata={handleLoadMetadata}
                                src={props.path}
                                className={classes.audioPlayers}
                            />

                        </ThemeProvider>
                        <Button className={classes.editbtn} onClick={handlePopupModalAdd}>
                            Edit
                        </Button>
                    </div>
                    <div style={{ textAlign: 'left', marginTop: '0px' }}>
                        {/* <p className={classes.filename}>Filename.mp3</p> */}
                        <span className={classes.filename}>{props.filename}</span>
                    </div>
                </div>
            </div>
        </>

    )

}
export default OpenHourGreetingsNew